import * as IF from "infrontjs";
import template from './template.html';

class HeaderBar extends HTMLElement
{
    static get observedAttributes()
    {
        return [ 'title' ];
    }

    constructor()
    {
        super();
        this._isConnected = false;
    }

    connectedCallback()
    {
        if ( false === this._isConnected )
        {
            this.root = this;
            this.app = IF.App.get();
            this.render();

            this.root.querySelector( '[data-id="btnToggleMenuSidebar"]' ).addEventListener( 'click', () =>
            {
                document.getElementById( 'menu-side' ).classList.add( 'menu-active' );
                document.querySelectorAll('.menu-hider')[0].classList.add('menu-active');
                document.querySelector( '[data-id="menu-backdrop"]' ).classList.add( 'menu-active' );
            });


            if ( false === document.body.hasAttribute( 'data-sidemenu-initialized' ) )
            {
                document.querySelector( '[data-id="btnLogout"]' ).addEventListener( 'click', () =>
                {
                    this.app.router.redirect( '/logout' );
                    setTimeout( () =>
                    {
                        window.location.reload();
                    }, 250 );
                });

                const sideMenu = document.getElementById( 'menu-side' );
                sideMenu.querySelectorAll( '[data-type="menu-item"]' ).forEach( ( item ) =>
                {
                    item.addEventListener( 'click', () =>
                    {
                        this.app.router.redirect( item.getAttribute( 'data-route' ) );
                        this.closeSideMenu();
                    });
                });

                document.querySelector( '[data-id="menu-backdrop"]' ).addEventListener( 'click', () =>
                {
                    this.closeSideMenu();
                });

                document.body.setAttribute( 'data-sidemenu-initialized', true );
            }

            this._isConnected = true;
        }
    }

    closeSideMenu()
    {
        const activeMenu = document.querySelectorAll('.menu-active');
        for(let i=0; i < activeMenu.length; i++){activeMenu[i].classList.remove('menu-active');}
    }

    disconnectedCallback()
    {
        this._isConnected = false;
    }

    attributeChangedCallback( name, oldVal, newVal )
    {}

    render()
    {
        const title = this.hasAttribute( 'title' ) ? this.getAttribute( 'title' ) : '';
        this.root.innerHTML = this.app.view.getHtml( template, { title : title.toUpperCase() } );
    }

}

customElements.define('header-bar', HeaderBar );
